import { urlFor } from '../lib/sanity'
import type { Post } from '../types/sanity'
import { Link } from 'react-router-dom'

interface BlogPostCardProps {
  post: Post
  featured?: boolean
}

export default function BlogPostCard({ post, featured = false }: BlogPostCardProps) {
  return (
    <Link 
      to={`/blog/${post.slug.current}`} 
      className={`block group no-underline w-full transition-all duration-300 ease-in-out hover:opacity-70 scale-100 hover:scale-[1.015] ${
        featured ? 'md:col-span-2' : ''
      }`}
    >
      <article className="relative bg-[#F7F7F7] w-full">
        {/* Image Container */}
        <div className={`relative w-full overflow-hidden rounded-lg ${
          featured ? 'aspect-[16/9] md:aspect-[21/12]' : 'aspect-[16/11]'
        }`}>
          <img
            src={urlFor(post.mainImage)
              .width(featured ? 1600 : 1200)
              .height(featured ? 915 : 825)
              .url()}
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Content Container */}
        <div className="flex flex-col md:flex-row justify-between items-start py-4 md:py-6 w-full">
          <div className="flex-1 pr-4 md:pr-8">
            <h2 className="headline-medium mb-2 md:mb-3 text-black">
              {post.title}
            </h2>
            <p className="body text-gray-600 line-clamp-2">
              {post.description}
            </p>
          </div>
          
          {/* Arrow */}
          <div className="flex items-center text-black mt-4 md:mt-0">
            <span className={`${featured ? 'text-2xl md:text-3xl' : 'text-xl md:text-2xl'}`}>→</span>
          </div>
        </div>
      </article>
    </Link>
  )
} 